import { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

const stripCountryCode = (str: string) => {
  const phone = str.replace(/[^+1234567890]/g, '');
  return isValidPhoneNumber(phone) && parsePhoneNumber(phone)?.nationalNumber;
};

export default stripCountryCode;
